import { Button, Descriptions, Flex, Modal } from "antd";
import { DescriptionsProps } from "antd/lib";
import dayjs from "dayjs";
import { FC, useState } from "react";
import { displayDateFormat } from "tm-shared/constants";

import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";
import { useAppDispatch } from "@/hooks/redux";
import { addModalToQueue } from "@/store/slices/ui";
import { ModalPayloads, ModalType } from "@/types/modals";

import { SelectableGallery } from "./SelectableGallery";

export interface CustomTaskAddPhotosModalProps {
    payload: ModalPayloads[ModalType.CustomTaskAddPhotos];
    onCloseModal: () => void;
}

const CustomTaskAddPhotosModal: FC<CustomTaskAddPhotosModalProps> = ({
    payload,
    onCloseModal,
}) => {
    const dispatch = useAppDispatch();
    const { market, task, images } = payload;
    const taskInfo = task?.info;
    const hasRealPerformer =
        taskInfo?.realPerformer?.userId !== taskInfo?.performer?.userId;
    const [selectedImages, setSelectedImages] = useState<string[]>([]);

    const taskViewInfoItems: DescriptionsProps["items"] = [
        {
            label: "Виконано:",
            children: dayjs(taskInfo?.context?.completedAt).format(
                displayDateFormat.dateTime,
            ),
        },
        {
            label: "Виконавець:",
            children: taskInfo?.realPerformer?.name,
        },
        ...(hasRealPerformer
            ? [
                  {
                      label: "Від імені:",
                      children: taskInfo?.performer?.name,
                  },
              ]
            : []),
        {
            label: "Роль:",
            children: taskInfo?.performer?.role,
        },
    ];

    const handleNext = () => {
        onCloseModal();
        dispatch(
            addModalToQueue({
                id: ModalType.CreateCustomTask,
                type: ModalType.CreateCustomTask,
                payload: {
                    market,
                    images: selectedImages,
                },
            }),
        );
    };

    return (
        <Modal
            open
            title=""
            closable
            centered
            onCancel={onCloseModal}
            footer={null}
            width="100%"
            style={{ maxWidth: 400 }}
            destroyOnClose
        >
            <PrimaryText
                textAlign="center"
                fontSize={16}
                fontWeight="500"
                padding="0 20px 0 0"
            >
                Створення доручення для ТТ &quot;{market?.name}&quot;
            </PrimaryText>
            <Flex vertical gap={24} style={{ marginTop: 24 }}>
                <Descriptions
                    styles={{
                        label: { padding: "4px 8px", width: 130 },
                        content: { padding: "4px 8px" },
                    }}
                    bordered
                    items={taskViewInfoItems}
                />

                {/* Gallery hint */}
                <SecondaryText>
                    Оберіть світлини, які ви хочете додати до доручення
                </SecondaryText>

                {/* Selectable gallery */}
                <SelectableGallery
                    images={images}
                    selectedImages={selectedImages}
                    onSelectionChange={setSelectedImages}
                />

                <Button
                    type="primary"
                    style={{ width: "100%", height: "50px" }}
                    onClick={handleNext}
                >
                    Далі
                </Button>
            </Flex>
        </Modal>
    );
};

export default CustomTaskAddPhotosModal;
